module.exports = __webpack_public_path__ + "img/member_banner.9dd2ef01.png";